import { type FC } from "react";

import { Button, Container } from "@snapchat/snap-design-system";
import { AddIcon } from "@snapchat/snap-design-system-icons";
import { FieldArray, useFormikContext } from "formik";

import { Flexbox } from "../../../../shared/components";
import { cardContainer } from "../api-settings/ApiEdit.styles";
import { AddEndpointButtonCta } from "../messages.generated";
import { type RemoteApiFormValues, initialEndpointValue } from "../schema/remoteApiSpecSchema";

import { EndpointEdit } from "./EndpointEdit";
import { buttonAdderStyle, buttonIcon } from "./endpoint.styles";

// TODO(LOOK-160933): - move text to messages
export const EndpointsEdit: FC = () => {
    const {
        values: { endpoints },
    } = useFormikContext<RemoteApiFormValues>();

    return (
        <FieldArray name="endpoints">
            {({ push, remove }) => {
                return (
                    <Container className={cardContainer}>
                        {endpoints.map((_endpoint, index) => {
                            return <EndpointEdit key={`endpoint-${index}`} index={index} onRemove={remove} />;
                        })}
                        <Flexbox justifyContent="center">
                            <Button
                                className={buttonAdderStyle}
                                onClick={() => {
                                    push(initialEndpointValue);
                                }}
                            >
                                <AddIcon className={buttonIcon} />
                                <AddEndpointButtonCta />
                            </Button>
                        </Flexbox>
                    </Container>
                );
            }}
        </FieldArray>
    );
};
